export const storageAlerts = {
	label: "Alertas de estoque",
	description:
		"Configure e gerencie alertas do seu estoque para não perder nenhuma movimentação",
	search: "Pesquisar produtos",
	btnAddEmail: "Configurar recebimento de alerta",
	btnAddProductAlert: "Adicionar alerta para um produto",
	titleAlertPhone: "Receba alertas pelo seu telefone!",
	descriptionAlertPhone:
		"Agora você pode cadastrar números de telefone para receber os alertas de estoque",
	addEmailModal: {
		title: "Configurar recebimento de alertas por email",
		name: "Nome",
		email: "Email",
		emptyText: "Sem emails cadastrados",
		phone: "Celular",
		placeholders: {
			name: "Digite o nome",
			email: "Digite o email",
			phone: "Digite o celular",
		},
	},
	addAlertModal: {
		title: "Adicionar novo alerta",
		selectProduct: "Selecione o produto",
		storageAlert: {
			label: "Alerta",
			storageIn: "Estoque em",
			below: "abaixo de",
		},
		storageCritic: {
			label: "CRÍTICO",
			storage: "Estoque",
			below: "abaixo de",
		},
		add: "Criar alerta",
		invalidText:
			"O valor de estoque em alerta não pode ser menor ou igual ao valor de estoque critico",
	},
	columns: {
		product: "PRODUTO",
		storageQuantity: "ESTOQUE ATUAL",
		storageAlert: {
			label: "ALERTA",
			storageIn: "ESTOQUE EM",
			from: "A PARTIR DE",
		},
		storageCritic: {
			label: "CRÍTICO",
			storage: "ESTOQUE",
			from: "A PARTIR DE",
		},
		actions: "AÇÕES",
	},
	filters: {
		ok: "Ok",
		storageAlert: "Estado de alerta",
		storageCritic: "Estado crítico",
	},
};
